module.exports = __webpack_public_path__ + "static/media/event-image.a84a5239.png";